export default {
  button: {
    toMainPage: "Main",
    login: "Log In",
    registration: "Sign Up",
    back: "Back",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Authorization",
  pageTab: {
    owner: "Owner",
    manager: "Manager",
  },
  form: {
    country: "Country",
    mail: "Email",
    login: "Username",
    password: "Password",
    repeatPass: "Confirm Password",
    minInputSize: "Must contain at least {size} characters",
  },
  noAccount: "Don't have an account?",
  forgotPassword: "Forgot password?",
  dontWorryAboutForgotPass:
    "Don't worry, we'll send a recovery link to your email",

  resetPass: {
    dontWorry: "Don't worry, we'll send a recovery link to your email",
    info: {
      title: "Login information sent to your email",
      sendedLink: "We've sent a password reset link to your email",
      checkSpam: "If you didn't receive the email, check your Spam folder",
    },
    resendMail: "Resend email in 00:%{timer}",
    messageNotReceived: "Didn't receive the email?",
    title: "Password Reset",
    enterNewPass:
      "Enter a new password that you'll use to log into your account",
  },
};
